var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('a', { staticClass: "toggle-side-bar", on: { "click": _vm.toggleSideBar } }, [_vm.isExpand ? _c('svg-icon', { staticClass: "arrow-right", attrs: { "icon-class": "arrow_right" } }) : _c('svg-icon', { staticClass: "arrow-left", attrs: { "icon-class": "arrow_left" } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };